import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1a85f95a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=1a85f95a&prod&scoped=true&lang=css"
import style1 from "@/assets/css/shared-styles/editBox.css?vue&type=style&index=1&id=1a85f95a&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a85f95a",
  null
  
)

export default component.exports